import { render, staticRenderFns } from "./Accounts.vue?vue&type=template&id=760beb20&"
import script from "./Accounts.vue?vue&type=script&lang=js&"
export * from "./Accounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('760beb20')) {
      api.createRecord('760beb20', component.options)
    } else {
      api.reload('760beb20', component.options)
    }
    module.hot.accept("./Accounts.vue?vue&type=template&id=760beb20&", function () {
      api.rerender('760beb20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Accounts.vue"
export default component.exports